import { JSX } from "react";

const ProvidersByStateDescription = (): JSX.Element => {
  return <>
    <p>
      The Providers By State card summarizes how your network is spread geographically at a state level.
      This view of the geographic footprint helps quickly identify where providers are concentrated and where there may be a limited network presence across various states.
    </p>
    <p>
      Providers without a State value will be grouped as “Unknown.”
    </p>
  </>;
}

export { ProvidersByStateDescription };